var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _g, _rect23, _path, _rect24, _rect25, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg19UpdatedNewTableArrivedDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 68,
    viewBox: "0 0 132 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.58203,
    y: 35.7422,
    width: 114.839,
    height: 24.5161,
    rx: 2.58065,
    fill: "#009823"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3887,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.002,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6152,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8398,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4531,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0664,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95.6797,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107.291,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2266,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3887,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.002,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6152,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8398,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4531,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0664,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 95.6797,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 107.291,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2266,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.839844,
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#B6B6B6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#009823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_4195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 40,
    width: 16,
    height: 16
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2266,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "url(#pattern0_190_4195)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_4195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.2266,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "white"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7109,
    y: 38.3228,
    width: 18.0645,
    height: 19.3548,
    rx: 2.58065,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5196 51.5V45.9103H68.188V45.0587C68.6147 45.0587 68.9588 45.0191 69.2203 44.94C69.4852 44.8574 69.6831 44.7404 69.8138 44.589C69.9446 44.4342 70.022 44.2501 70.0461 44.0368H71.0474V51.5H69.5196ZM75.3543 51.6135C74.8898 51.6135 74.4562 51.5241 74.0537 51.3452C73.6511 51.1662 73.3225 50.9151 73.0679 50.5916C72.8132 50.2647 72.6704 49.8828 72.6395 49.4458H74.0743C74.1362 49.7348 74.2739 49.9705 74.4872 50.1529C74.7005 50.3318 74.9689 50.4213 75.2924 50.4213C75.6502 50.4213 75.9633 50.337 76.2317 50.1684C76.5035 49.9998 76.7066 49.7314 76.8408 49.3632C76.9784 48.9951 77.0266 48.5133 76.9853 47.9181C76.8889 48.1004 76.7547 48.2604 76.5827 48.3981C76.4141 48.5323 76.2162 48.6372 75.9891 48.7129C75.762 48.7852 75.5091 48.8213 75.2304 48.8213C74.7246 48.8213 74.2756 48.7267 73.8833 48.5374C73.4945 48.3447 73.1883 48.0729 72.9646 47.7219C72.7444 47.3675 72.6343 46.9477 72.6343 46.4626C72.6343 45.974 72.7513 45.5387 72.9853 45.1568C73.2192 44.7748 73.5461 44.4755 73.9659 44.2587C74.3857 44.0419 74.8777 43.9335 75.442 43.9335C76.0752 43.9335 76.6205 44.0849 77.0782 44.3877C77.5392 44.6871 77.8919 45.1138 78.1362 45.6677C78.384 46.2183 78.5078 46.8669 78.5078 47.6135C78.5078 48.5047 78.3805 49.248 78.1259 49.8432C77.8747 50.4351 77.5134 50.8789 77.042 51.1748C76.5706 51.4673 76.0081 51.6135 75.3543 51.6135ZM75.4885 47.6239C75.6984 47.6239 75.9014 47.5774 76.0975 47.4845C76.2971 47.3882 76.4605 47.2677 76.5879 47.1232C76.7152 46.9787 76.7788 46.829 76.7788 46.6742C76.7823 46.3404 76.7289 46.0548 76.6188 45.8174C76.5122 45.5766 76.3608 45.3925 76.1646 45.2652C75.9719 45.1378 75.7466 45.0742 75.4885 45.0742C75.2511 45.0742 75.0395 45.1292 74.8537 45.2394C74.6679 45.3495 74.5216 45.5043 74.4149 45.7039C74.3083 45.9034 74.2549 46.134 74.2549 46.3955C74.2549 46.7843 74.3685 47.0871 74.5956 47.3039C74.8227 47.5172 75.1203 47.6239 75.4885 47.6239Z",
    fill: "#009823"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 1,
    width: 23.2632,
    height: 22,
    rx: 11,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 1,
    width: 23.2632,
    height: 22,
    rx: 11,
    stroke: "#009823",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.951 14.464V8.794H114.229V14.464H112.951ZM110.749 12.274V10.996H116.419V12.274H110.749ZM117.797 16V15.136V14.692C117.797 14.252 117.879 13.872 118.043 13.552C118.207 13.228 118.423 12.948 118.691 12.712C118.963 12.472 119.259 12.262 119.579 12.082C119.903 11.902 120.227 11.732 120.551 11.572C120.875 11.412 121.171 11.252 121.439 11.092C121.711 10.928 121.929 10.746 122.093 10.546C122.257 10.346 122.339 10.11 122.339 9.838C122.339 9.49 122.217 9.206 121.973 8.986C121.733 8.766 121.403 8.656 120.983 8.656C120.547 8.656 120.177 8.782 119.873 9.034C119.569 9.286 119.381 9.666 119.309 10.174H117.635C117.643 9.622 117.771 9.122 118.019 8.674C118.271 8.222 118.647 7.864 119.147 7.6C119.647 7.336 120.275 7.204 121.031 7.204C121.679 7.204 122.237 7.314 122.705 7.534C123.177 7.754 123.541 8.06 123.797 8.452C124.053 8.844 124.181 9.302 124.181 9.826C124.181 10.262 124.101 10.638 123.941 10.954C123.781 11.27 123.569 11.54 123.305 11.764C123.041 11.988 122.751 12.184 122.435 12.352C122.119 12.52 121.803 12.676 121.487 12.82C121.175 12.964 120.887 13.112 120.623 13.264C120.359 13.412 120.147 13.58 119.987 13.768C119.827 13.956 119.747 14.182 119.747 14.446V14.524H124.169V16H117.797Z",
    fill: "#009823"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_190_4195",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_190_4195",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_190_4195",
    width: 512,
    height: 512,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19UpdatedNewTableArrivedDuplicate);
export default __webpack_public_path__ + "static/media/19-updated-new-table-arrived-duplicate.8cd4d2e9c897dc03a06a702e3a538ac7.svg";
export { ForwardRef as ReactComponent };